<template>
  <bootstrap-modal
    :modal-title="modalTitle"
    :is-open="isModalOpen"
    :can-submit="canSubmit"
    size="lg"
    @modal:close="closeStudentEnrollmentModal"
    @modal:okay="submitStudentEnrollment"
  >
    <div class="col-12">
      <div class="row justify-content-center">
        <div class="col-10 mb-4">
          <p class="text-center">
            請更新報名狀態為正確資訊，俾利主辦單位辦理相關事項
          </p>
        </div>
      </div>
    </div>
    <div class="col">
      <form>
        <form-row>
          <form-group
            cols="3"
            label="* 學號"
          >
            <input-group>
              <form-input
                v-model="currentStudentGetter.student_id"
                name="student_id"
                placeholder=""
                readonly
              />
            </input-group>
          </form-group>
          <form-group
            cols="3"
            label="* 姓名"
          >
            <input-group>
              <form-input
                v-model="enrollment.student_name"
                name="student_name"
                id="studentNameField"
                
              />
            </input-group>
          </form-group>
          <form-group cols="3" label="* 性別">
            <input-group>
              <form-select :default-value="currentStudentGetter.student_sex" :options="[{
                  name: '男',
                  value: 1,
                }, {
                  name: '女',
                  value: 0,
                }]" id="genderField" name="sex" @change="sexSelected" required/>
            </input-group>
          </form-group>
          <form-group
            cols="3"
            label="* 系所"
          >
            <input-group>
              <form-input
                v-model.trim="studentDepartment"
                name="student_name"
                readonly
              />
            </input-group>
          </form-group>
        </form-row>
        <form-row>
          <form-group
            cols="6"
            label="* E-mail"
          >
            <input-group>
              <template slot="append">
                <span
                  aria-hidden="true"
                  class="input-group-text text-muted btn-pill"
                >
                  ＠mail.ntust.edu.tw
                </span>
              </template>
              <form-input
                v-model="currentStudentGetter.student_id"
                name="student_id"
                readonly
              />
            </input-group>
          </form-group>
          <form-group
            cols="6"
            label="備用電子信箱"
          >
            <input-group>
              <form-input
                v-model="enrollment.student_alternate_email"
                name="student_alternate_email"
              />
            </input-group>
          </form-group>
        </form-row>
        <form-row>
          <form-group
            cols="6"
            label="* 電話"
          >
            <input-group>
              <form-input
                v-model="enrollment.student_tel"
                name="student_phone_number"
                id="studentPhoneNumber"
              />
            </input-group>
          </form-group>
          <form-group
            cols="6"
            label="備用電話"
          >
            <input-group>
              <form-input
                v-model="enrollment.student_alternate_phone_number"
                name="student_alternate_phone_number"
              />
            </input-group>
          </form-group>
        </form-row>
        <form-row v-if="doesNeedTravelAccidentInsurance">
          <form-group
            cols="6"
            label="* 生日"
          >
            <date-time-picker
              v-model="enrollment.student_birthday"
              input-name="student-birthday"
              :max-datetime="$moment().toISOString(true)"
              format="yyyy/LL/dd"
            >
              <span
                slot="before"
                aria-hidden="true"
                class="input-group-text text-muted btn-pill"
              >
                <font-awesome-icon icon="calendar-alt" />
              </span>
            </date-time-picker>
          </form-group>
          <form-group
            cols="6"
            label="* 身份證字號"
          >
            <input-group>
              <form-input
                v-model="enrollment.student_id_card_number"
                name="student_id_card_number"
              />
            </input-group>
          </form-group>
        </form-row>
        <form-row v-if="doesNeedBeverage">
          <form-group cols="6" label="* 飲食偏好">
            <input-group>
              <form-select :default-value="currentStudentGetter.student_foods" :options="[{
                  name: '葷',
                  value: 1,
                }, {
                  name: '素',
                  value: 0,
                }]" id="foodsField" name="foods" @change="foodsSelected" required/>
            </input-group>
          </form-group>
        </form-row>
        <form-row>
          <div class="col">
            <div
              class="form-check"
            >
              <check-input
                label="同意"
                name="agree-policy"
                @change="isAgreePrivacyPolicy"
              >
                <template
                  slot="label"
                >
                  <button-wrapper
                    thickness="xs"
                    @click.prevent="openPolicyWindow"
                  >
                    隱私權政策的適用範圍及個人資料安全之保護聲明」
                  </button-wrapper>
                </template>
              </check-input>
            </div>
          </div>
        </form-row>
      </form>
    </div>
  </bootstrap-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import BootstrapModal from '~bootstrap/Modal'
import FormRow from '~components/common/form/Row'
import FormGroup from '~components/common/form/Group'
import FormInput from '~components/common/form/input'
import CheckInput from '~components/common/form/input/Check'
import InputGroup from '~components/common/form/input/Group'
import FormSelect from '~components/common/form/Select'
import DateTimePicker from '~lar/DateTimePicker'
import ButtonWrapper from '~components/common/buttons'
export default {
  name: 'StudentEnrollEventModal',
  components: {
    BootstrapModal,
    FormRow,
    FormGroup,
    FormInput,
    CheckInput,
    InputGroup,
    DateTimePicker,
    ButtonWrapper,
    FormSelect,
  },
  props: {
    isModalOpen: Boolean,
    modalTitle: {
      type: String,
      required: true
    },
    doesNeedTravelAccidentInsurance: Boolean,
    doesNeedBeverage: Boolean
  },
  data () {
    return {
      enrollment: {
        student_alternate_email: '',
        sex: 1,
      },
      canSubmit: false
    }
  },
  computed: {
    ...mapGetters('pages/students', [
      'currentStudentGetter',
      'getStudentDepartmentById',
      'getAcademicDegreeByCode'
    ]),
    studentDepartment () {
      if (!Object.keys(this.currentStudentGetter).length) {
        return ''
      }

      let degree = this.getAcademicDegreeByCode(this.currentStudentGetter.student_academic_degree)
      let department = this.getStudentDepartmentById(this.currentStudentGetter.student_department)
      let grade = this.currentStudentGetter.student_grade

      return [degree,department?.department_name,`${grade}年級`].filter(s=>s).join('/');
    }
  },
  created () {
    this.enrollment.student_name = this.currentStudentGetter.student_name;
    this.enrollment.student_tel = this.currentStudentGetter.student_phone_number;
    this.enrollment.student_alternate_email = this.currentStudentGetter.student_alt_email;
    this.enrollment.sex = this.currentStudentGetter.student_sex;
    this.enrollment.foods = this.currentStudentGetter.student_foods;
  },
  methods: {
    sexSelected(e) {
      this.enrollment.sex = e.value
    },
    foodsSelected(e) {
      this.enrollment.foods = e.value
    },
    closeStudentEnrollmentModal () {
      this.$emit('modal:close')
    },
    submitStudentEnrollment () {
      if (this.canSubmit) {

        let nameField = document.getElementById("studentNameField");
        let telField = document.getElementById("studentPhoneNumber");

        // 姓名驗證: 只能包含 中文、英文、空格、- 及 () [] {}
        let nameRegex = /^[\u4e00-\u9fa5A-Za-z\s\-\(\)\[\]\{\}]+$/;
        if (this.enrollment.student_name === "") {
            nameField.setCustomValidity("姓名欄位不能為空");
            nameField.reportValidity();
            return;
        } else if (!nameRegex.test(this.enrollment.student_name)) {
            nameField.setCustomValidity("姓名只能包含中文、英文、空格、- 及括號");
            nameField.reportValidity();
            return;
        } 
      
        let telRegex = /^[\d+\-()]+$/;
        if (this.enrollment.student_tel === "") {
            telField.setCustomValidity("電話欄位不能為空");
            telField.reportValidity();
            return;
        } else if (!telRegex.test(this.enrollment.student_tel)) {
            telField.setCustomValidity("請輸入有效的電話號碼");
            telField.reportValidity();
            return;
        }

        if(this.enrollment.sex === "") {
          document.getElementById("genderField").setCustomValidity("此欄位不能爲空");
          document.getElementById("genderField").reportValidity();
          return;
        }

        this.$emit('modal:close')
        this.$emit('submit', this.enrollment)
      }
    },
    openPolicyWindow () {
      const target = this.$router.resolve('/privacy-policy')
      window.open(target.href, '_blank')
    },
    isAgreePrivacyPolicy (value) {
      this.canSubmit = value
    }
  }
}
</script>
